import BaseModel from '../core/BaseModel'
export default class ServiceUnitModel extends BaseModel {
    constructor() {
        super({
                name: "service_unit",
                tableName: 'core_service_unit',
                display_key: 'name'
            },
            {
                code: {
                    name: 'code',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                name: {
                    name: 'name',
                    type: "String",
                    label: '--',
                }
            },)
    }

}